export const scrollToViewListener = () => {
    const scrollToElements = [...document.querySelectorAll('.js-scroll-to-view')].filter(
        (el) => el.dataset.scrollTo && !el.dataset.scrollToViewInitialized
    );

    scrollToElements.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();

            const elementToScrollTo = document.querySelector(`${el.dataset.scrollTo}`);

            if (elementToScrollTo) {
                const top = elementToScrollTo.offsetTop;
                const scrollOptions = {
                    top: top,
                    behavior: 'smooth',
                };
                window.scrollTo(scrollOptions);
            } else {
                console.error('Element to scroll to not found:', el.dataset.scrollTo);
            }
        });

        el.dataset.scrollToViewInitialized = true;
    });
};
